var _path;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgBrokenImage = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.9,8.6c-0.1-0.2-0.4-0.4-0.6-0.5L24.2,4.6c-0.3-0.1-0.7,0-0.9,0.2C23,5,22.9,5.4,22.9,5.7l0.9,5.7l-0.5,1.2 l1.8,0.8l0.6-1.5l4.6,1.2l-3.5,13l-4.7-1.3l0.3-2.1l-2-0.3L20,25.7l-2.4,3.9c-0.1,0.2-0.2,0.4-0.1,0.7l0.5,3.6 c0.1,0.4,0.3,0.7,0.7,0.8l10.7,2.9c0.1,0,0.2,0,0.3,0c0.4,0,0.8-0.3,1-0.7L38,9.3C38,9.1,38,8.8,37.9,8.6z M28.9,35.4L19.8,33 l-0.4-2.6l2.3-3.6l5.6,1.6c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.4-0.4,0.5-0.6l4-14.9c0.1-0.5-0.2-1.1-0.7-1.2 l-6.2-1.7l-0.5-2.9l10.6,2.9L28.9,35.4z M15.8,30.6l2.4-4.7c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0-0.1 c0,0,0,0,0,0c0,0,0,0,0-0.1L18,22.4h-2l0.2,2h-6V10.9h6l0.1,0.2l-0.2,1.2l2-0.2l0.1-1.1c0-0.2,0-0.4-0.1-0.6l-2.7-5.6 c-0.2-0.3-0.5-0.6-0.9-0.6H5c-0.6,0-1,0.4-1,1v28.5c0,0.6,0.4,1,1,1h11.2c0.3,0,0.7-0.2,0.8-0.5c0.2-0.3,0.2-0.6,0.1-0.9L15.8,30.6 z M13.7,30.9l0.9,2H6V6.4h8l1.2,2.5h-6c-0.6,0-1,0.4-1,1v15.5c0,0.6,0.4,1,1,1h6.5l-1.9,3.6C13.6,30.3,13.6,30.6,13.7,30.9z  M17.7,13.7L20,16l2.3-2.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-2.3,2.3l2.3,2.3c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0 c0,0,0,0,0,0L20,18.8l-2.3,2.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l2.3-2.3l-2.3-2.3c-0.4-0.4-0.4-1,0-1.4 C16.7,13.3,17.3,13.3,17.7,13.7z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrokenImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/broken-image.7af7e03b.svg";
export { ForwardRef as ReactComponent };